type ClosestFunction = {
  <K extends keyof HTMLElementTagNameMap>(
    e: EventTarget | null | undefined,
    selector: K
  ): HTMLElementTagNameMap[K] | null;
  <K extends keyof SVGElementTagNameMap>(
    e: EventTarget | null | undefined,
    selector: K
  ): SVGElementTagNameMap[K] | null;
  <E extends Element = Element>(
    e: EventTarget | null | undefined,
    selector: string
  ): E | null;
};

export const closest: ClosestFunction = (
  eventTarget: EventTarget | null | undefined,
  selector: string
) => (eventTarget instanceof Element ? eventTarget.closest(selector) : null);

const isNodeElement = (node: Node): node is HTMLElement =>
  node.nodeType === Node.ELEMENT_NODE;

export const isEditableElement = (node: Node): boolean => {
  // https://stackoverflow.com/questions/26723648/check-whether-an-html-element-is-editable-or-not-using-js
  const nodeName = node.nodeName.toLowerCase();
  return (
    (node as HTMLElement).isContentEditable ||
    (isNodeElement(node) &&
      (nodeName === 'textarea' ||
        (nodeName === 'input' &&
          /^(?:text|email|number|search|tel|url|password)$/i.test(
            (node as HTMLInputElement).type
          ))))
  );
};

export const clearSelection = () => {
  let selection = null;
  if (window.getSelection) {
    selection = window.getSelection();
    // @ts-expect-error todo
  } else if (document.selection) {
    // @ts-expect-error todo
    selection = document.selection;
  }
  if (selection) {
    if (selection.empty) {
      selection.empty();
    }
    if (selection.removeAllRanges) {
      selection.removeAllRanges();
    }
  }
};
